/**
 * Purpose:
 *   Warm protected routes on menu hover/focus before navigation.
 *
 * Notes:
 *   - Idempotent per href per page load.
 *   - Subscriptions list also preloads the table chunk.
 */

type TPrefetchRoute = (href: string) => void;

const prefetchedRoutes = new Set<string>();

export function resetPrefetchRouteOnIntentForTests(): void {
  prefetchedRoutes.clear();
}

export function prefetchRouteOnIntent(
  href: string,
  prefetchRoute: TPrefetchRoute,
  warmChunk?: () => void
): void {
  if (!href || prefetchedRoutes.has(href)) {
    return;
  }

  prefetchedRoutes.add(href);
  prefetchRoute(href);

  if (href === '/subscriptions') {
    warmChunk?.();
  }
}